import net, { IRequestOptions, IRequestOptionsWithPass } from '@/services/net'
import { PackEntityCloudCallFunctionOverViewVO } from '../Type/PackEntityCloudCallFunctionOverViewVO'

interface DataModel {
	aid?: string
	cid?: string
}

/**
 *	查询云呼叫中心功能状态、保证金、appKey
 * @param {DataModel} [data] 封装对象
 * @param {string} [data.aid] 描述缺失
 * @param {string} [data.cid] 描述缺失
 */

export function funccloudCalloverview(
	data: DataModel,
	options: IRequestOptionsWithPass,
): Promise<PackEntityCloudCallFunctionOverViewVO>
export function funccloudCalloverview(
	data: DataModel,
	options?: IRequestOptions,
): Promise<
	PackEntityCloudCallFunctionOverViewVO extends { msg: unknown }
		? PackEntityCloudCallFunctionOverViewVO['msg']
		: undefined
>
export function funccloudCalloverview(data: DataModel, options: IRequestOptionsWithPass | IRequestOptions = {}) {
	const { aid, cid } = data
	return net('/frontApi/app/func/cloudCall/overview', {
		method: 'post',
		params: {
			aid,
			cid,
		},

		...(options || {}),
	})
}
